<template>
	<v-dialog v-model="openDialog" persistent max-width="290">
		<v-card>
			<v-toolbar card color="primary">
				<h1>Código Indica-me</h1>
			</v-toolbar>
			<v-spacer></v-spacer>
			<v-card-text> {{ code }} </v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="green_strong" flat @click="copyCode()">Copiar código</v-btn>
				<v-btn color="error" flat @click="closeDialog(false)">Fechar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { copyToClipboard } from '@Util/functions';

export default {
	name: 'DialogIndicame',
	data: () => ({
	}),
	props: {
		openDialog: {
			type: Boolean,
			required: true
		},
		code: {
			type: String,
			required: true
		}
	},
	methods: {
		closeDialog(value) {
			this.$emit('closeDialog', value);
		},
		copyCode() {
			copyToClipboard(this.code);
		}
	}
};
</script>

<style scoped>

</style>
